import { ACTIVE_CLASS_NAME } from 'modules/nav/constants';
import { NavbarOption } from 'modules/nav/types';
import { NavLink, useLocation } from 'react-router-dom';
import { HEADER_NAV_ICONS } from 'ui/icons/headerNavigation/constants';
import { camelCase } from 'utils/stringHelpers';
import {
  Description,
  IconContainer,
  LinkNav,
  SubLink,
  Subsection,
  Title,
} from './LinkContainer.styled';

export const NavigationMenuLinks = ({ option }: { option: NavbarOption }) => {
  const { icon, title, pageDescription, links = [] } = option;
  const location = useLocation();

  return (
    <Subsection key={camelCase(title)} data-test="navigation-menu-links">
      {icon && <IconContainer>{HEADER_NAV_ICONS[icon]}</IconContainer>}
      <Title isHeading>{title}</Title>
      {pageDescription && <Description>{pageDescription}</Description>}
      <LinkNav data-test="sub-links">
        {links.map(({ isExternal, href, label }) => (
          <span key={href}>
            <SubLink
              as={isExternal ? 'a' : NavLink}
              activeClassName={ACTIVE_CLASS_NAME}
              className={!isExternal && location.pathname === href ? ACTIVE_CLASS_NAME : undefined}
              data-test="link"
              data-type={isExternal ? 'anchor' : 'navlink'}
              to={isExternal ? undefined : href}
              href={isExternal ? href : undefined}
            >
              {label}
            </SubLink>
          </span>
        ))}
      </LinkNav>
    </Subsection>
  );
};
